import React from 'react';
import { User } from 'lucide-react';

export function CreatedByBadge({ name, className = '' }) {
  if (!name) return null;
  return (
    <span 
      data-testid={`created-by-${name}`}
      className={`inline-flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded bg-[#223347]/60 text-[#A8B8CA] ${className}`}
    >
      <User size={10} className="flex-shrink-0" />
      {name}
    </span>
  );
}
